package tools

val String.csplit: List<String> get() = this.split(' ').filter { it.isNotBlank() }